<template>
  <div>
    <!-- Etapa E: trilha de auditoria. A Comissão vê a área "eleicao"; o
         Administrador vê "acesso", "usuarios" e "sistema" (o servidor aplica). -->
    <div>
      <h3 class="h3-responsive module-header">Auditoria</h3>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-6 col-md-3 col-lg-2">
            <label for="audDe">De</label>
            <input id="audDe" type="date" class="form-control" v-model="filtro.de" />
          </div>
          <div class="col-sm-6 col-md-3 col-lg-2">
            <label for="audAte">Até</label>
            <input id="audAte" type="date" class="form-control" v-model="filtro.ate" />
          </div>
          <div class="col-sm-6 col-md-3 col-lg-2" v-if="areas.length > 1">
            <label for="audArea">Área</label>
            <select id="audArea" class="browser-default custom-select" v-model="filtro.area">
              <option value="">Todas</option>
              <option v-for="a in areas" :key="a" :value="a">{{ rotuloArea(a) }}</option>
            </select>
          </div>
          <div class="col-sm-6 col-md-3 col-lg-2">
            <label for="audEvento">Evento</label>
            <select id="audEvento" class="browser-default custom-select" v-model="filtro.evento">
              <option value="">Todos</option>
              <option v-for="e in eventos" :key="e" :value="e">{{ rotuloEvento(e) }}</option>
            </select>
          </div>
          <div class="col-sm-6 col-md-3 col-lg-2">
            <label for="audResultado">Resultado</label>
            <select id="audResultado" class="browser-default custom-select" v-model="filtro.resultado">
              <option value="">Todos</option>
              <option value="ok">OK</option>
              <option value="recusado">Recusado</option>
              <option value="erro">Erro</option>
            </select>
          </div>
          <div class="col-sm-6 col-md-3 col-lg-2">
            <label for="audUsuario">Usuário</label>
            <input id="audUsuario" type="text" class="form-control" v-model="filtro.usuario" maxlength="64" v-on:keyup.enter="buscar(1)" />
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4" v-if="eleicoes.length">
            <label for="audEleicao">Eleição</label>
            <select id="audEleicao" class="browser-default custom-select" v-model="filtro.eleicao">
              <option value="">Todas</option>
              <option v-for="el in eleicoes" :key="el.id" :value="el.id">{{ el.strdescricao }}</option>
            </select>
          </div>
        </div>
        <div class="mt-3">
          <button class="btn btn-primary btn-sm ml-0" :disabled="carregando" @click="buscar(1)"><i class="fa fa-search"></i>&nbsp;Filtrar</button>
          <button class="btn btn-outline-secondary btn-sm" :disabled="carregando" @click="limpar"><i class="fa fa-eraser"></i>&nbsp;Limpar</button>
          <button class="btn btn-outline-primary btn-sm" :disabled="exportando" @click="exportar"><i class="fa fa-file-csv"></i>&nbsp;Exportar CSV</button>
          <button class="btn btn-outline-success btn-sm" :disabled="verificando" @click="verificar"><i class="fa fa-shield-alt"></i>&nbsp;Verificar integridade</button>
        </div>

        <div v-if="integridade" class="alert mt-3 mb-0" :class="integridade.ok ? 'alert-success' : 'alert-danger'">
          <template v-if="integridade.ok">
            <strong>Trilha íntegra.</strong> {{ integridade.total }} registro(s), nenhuma alteração ou remoção.
          </template>
          <template v-else>
            <strong>Problema na trilha de auditoria.</strong> Acione a DTI e registre em ata.
            <ul class="mb-0"><li v-for="(p, i) in integridade.problemas" :key="i">Registro {{ p.id }}: {{ p.problema }}</li></ul>
          </template>
          <div class="small mt-1">Último registro nº <strong>{{ integridade.ultimo_id }}</strong>, hash
            <code class="hash">{{ integridade.ultimo_hash || '—' }}</code>
            <span class="text-muted">(pode ser lançado em ata: qualquer alteração anterior a ele é detectada)</span>
          </div>
        </div>

        <div class="table-responsive mt-3">
          <table class="table table-sm table-striped tabela-auditoria">
            <thead>
              <tr>
                <th>#</th>
                <th>Data e hora</th>
                <th>Evento</th>
                <th>Resultado</th>
                <th>Usuário</th>
                <th>IP</th>
                <th>Detalhes</th>
              </tr>
            </thead>
            <tbody>
              <tr class="text-center" v-if="carregando"><td colspan="7"><Loading /></td></tr>
              <tr class="text-center" v-if="!carregando && !registros.length"><td colspan="7">Nenhum registro encontrado</td></tr>
              <template v-for="r in registros">
                <tr :key="'l' + r.id">
                  <td class="text-muted">{{ r.id }}</td>
                  <td class="text-nowrap">{{ dataHora(r.dtaevento) }}</td>
                  <td>{{ rotuloEvento(r.strevento) }}
                    <small v-if="r.inteleicaoid" class="d-block text-muted">eleição {{ nomeEleicao(r.inteleicaoid) }}</small>
                  </td>
                  <td><span class="badge badge-custom" :class="corResultado(r.strresultado)">{{ rotuloResultado(r.strresultado) }}</span></td>
                  <td>{{ r.strusuario || '—' }}<small v-if="r.intidperfil" class="d-block text-muted">{{ rotuloPerfil(r.intidperfil) }}</small></td>
                  <td class="text-nowrap"><small>{{ r.strip || '—' }}</small></td>
                  <td class="col-detalhes">
                    <small>{{ resumo(r) }}</small>
                    <a v-if="r.jsondetalhes" href="javascript:;" class="d-block small" @click="alternar(r.id)">{{ abertos.includes(r.id) ? 'ocultar' : 'ver tudo' }}</a>
                  </td>
                </tr>
                <tr v-if="abertos.includes(r.id)" :key="'d' + r.id">
                  <td colspan="7"><pre class="detalhes mb-0">{{ JSON.stringify(r.jsondetalhes, null, 2) }}</pre>
                    <small class="text-muted">hash {{ r.strhash }}</small></td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <div class="d-flex justify-content-between align-items-center" v-if="total">
          <small>{{ total }} registro(s) — página {{ pagina }} de {{ paginas }}</small>
          <div>
            <button class="btn btn-sm btn-outline-primary" :disabled="pagina <= 1 || carregando" @click="buscar(pagina - 1)">&laquo; Anterior</button>
            <button class="btn btn-sm btn-outline-primary" :disabled="pagina >= paginas || carregando" @click="buscar(pagina + 1)">Próxima &raquo;</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from './../misc/Loading'
import profile from './../../profile'

const EVENTOS = {
  'login': 'Login',
  'eleicao.cadastrar': 'Cadastro de eleição', 'eleicao.alterar': 'Alteração de eleição', 'eleicao.publicar': 'Publicação do resultado',
  'eleicao.justificar': 'Justificativa', 'eleicao.apagar': 'Exclusão de eleição', 'eleicao.recuperar': 'Recuperação de eleição',
  'eleicao.iniciar': 'Início da eleição (lacre da urna)', 'eleicao.finalizar': 'Finalização e apuração',
  'eleicao.zeresima': 'Zerésima (urna vazia no início)', 'eleicao.prorrogar': 'Prorrogação do horário final',
  'eleicao.conferir_frase': 'Conferência de frase-senha', 'eleicao.reenviar_comprovantes': 'Reenvio de comprovantes',
  'candidato.cadastrar': 'Cadastro de candidato', 'candidato.alterar': 'Alteração de candidato', 'candidato.apagar': 'Exclusão de candidato',
  'candidato.recuperar': 'Recuperação de candidato',
  'eleitor.cadastrar': 'Inclusão de eleitor(es)', 'eleitor.alterar': 'Alteração de eleitor', 'eleitor.apagar': 'Exclusão de eleitor',
  'eleitor.apagar_todos': 'Exclusão de eleitor(es) da eleição', 'eleitor.recuperar': 'Recuperação de eleitor',
  'upload.cadastrar': 'Envio de foto', 'upload.apagar': 'Exclusão de foto', 'upload.recuperar': 'Recuperação de foto',
  'usuario.cadastrar': 'Cadastro de usuário', 'usuario.alterar': 'Alteração de usuário', 'usuario.desativar': 'Desativação de usuário',
  'usuario.reativar': 'Reativação de usuário', 'usuario.trocar_senha': 'Troca de senha', 'usuario.importar_ad': 'Importação do AD',
  'auditoria.exportar': 'Exportação da auditoria', 'sistema.inicio': 'Inicialização do sistema',
  'sistema.migracao': 'Migração do banco aplicada', 'sistema.migracoes_pendentes': 'Migrações do banco pendentes'
};
const MOTIVOS = {
  sucesso: 'entrou', credenciais: 'usuário ou senha incorretos', nao_habilitado: 'conta da rede sem cadastro no eVoto',
  conta_local_recusada: 'conta local recusada (AD ligado)', bloqueio_tentativas: 'bloqueado por excesso de tentativas',
  ad_indisponivel: 'AD indisponível', parametros: 'dados incompletos', login_ambiguo: 'login ambíguo no cadastro', erro_interno: 'erro interno'
};

export default {
  name: 'auditoria',
  components: { Loading },
  data() {
    return {
      filtro: { de: '', ate: '', area: '', evento: '', resultado: '', usuario: '', eleicao: '' },
      registros: [], total: 0, pagina: 1, tamanho: 50,
      areas: [], eventos: [], eleicoes: [], abertos: [],
      carregando: false, exportando: false, verificando: false, integridade: null
    };
  },
  computed: {
    paginas() { return Math.max(1, Math.ceil(this.total / this.tamanho)); }
  },
  mounted() {
    this.buscar(1);
    if (profile().isComissao) {
      axios.get('/eleicoes/listar').then(res => { this.eleicoes = res.data.eleicoes || []; }).catch(() => {});
    }
  },
  methods: {
    parametros() {
      const p = {};
      Object.keys(this.filtro).forEach(k => { if (this.filtro[k] !== '' && this.filtro[k] !== null) p[k] = this.filtro[k]; });
      return p;
    },
    async buscar(pagina) {
      this.carregando = true;
      await axios.get('/auditoria', { params: Object.assign({ pagina, tamanho: this.tamanho }, this.parametros()) })
        .then(res => {
          this.registros = res.data.registros || [];
          this.total = res.data.total || 0;
          this.pagina = res.data.pagina || pagina;
          this.areas = res.data.areas || [];
          this.eventos = res.data.eventos || [];
          this.abertos = [];
        }, e => toastr.error((e.response && e.response.data && e.response.data.mensagem) || 'Falha ao consultar a auditoria'));
      this.carregando = false;
    },
    limpar() {
      Object.keys(this.filtro).forEach(k => { this.filtro[k] = ''; });
      this.buscar(1);
    },
    async exportar() {
      this.exportando = true;
      await axios.get('/auditoria/exportar', { params: this.parametros(), responseType: 'blob' })
        .then(res => {
          const url = URL.createObjectURL(res.data);
          const a = document.createElement('a');
          a.href = url;
          a.download = `evoto-auditoria-${new Date().toISOString().slice(0, 10)}.csv`;
          document.body.appendChild(a); a.click(); a.remove();
          setTimeout(() => URL.revokeObjectURL(url), 1000);
        }, () => toastr.error('Falha ao exportar a auditoria'));
      this.exportando = false;
    },
    async verificar() {
      this.verificando = true;
      await axios.get('/auditoria/verificar')
        .then(res => { this.integridade = res.data; },
              () => toastr.error('Falha ao verificar a integridade'));
      this.verificando = false;
    },
    alternar(id) {
      const i = this.abertos.indexOf(id);
      if (i >= 0) this.abertos.splice(i, 1); else this.abertos.push(id);
    },
    dataHora(d) {
      try { return new Date(d).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' }); } catch (e) { return d; }
    },
    rotuloEvento(e) { return EVENTOS[e] || e; },
    rotuloArea(a) { return { acesso: 'Acesso', usuarios: 'Usuários', eleicao: 'Eleições', sistema: 'Sistema' }[a] || a; },
    rotuloResultado(r) { return { ok: 'OK', recusado: 'Recusado', erro: 'Erro' }[r] || r; },
    corResultado(r) { return { ok: 'badge-success', recusado: 'badge-warning', erro: 'badge-danger' }[r] || 'badge-secondary'; },
    rotuloPerfil(p) {
      const env = process.env;
      return { [env.VUE_APP_PERMISSAO_ADMINISTRADOR]: 'Administrador', [env.VUE_APP_PERMISSAO_COMISSAO]: 'Comissão', [env.VUE_APP_PERMISSAO_ELEITOR]: 'Eleitor' }[String(p)] || '';
    },
    nomeEleicao(id) {
      const el = this.eleicoes.find(x => String(x.id) === String(id));
      return el ? el.strdescricao : '#' + id;
    },
    /** Uma linha legível com o principal de cada evento. */
    resumo(r) {
      const d = r.jsondetalhes || {};
      const partes = [];
      if (d.motivo) partes.push(MOTIVOS[d.motivo] || d.motivo);
      if (d.metodo) partes.push(d.metodo === 'ad' ? 'senha da rede' : 'senha local');
      if (d.login === '(inexistente)') partes.push('login inexistente (texto digitado não é gravado)');
      if (d.login_rede) partes.push('login da rede: ' + d.login_rede);
      if (d.mensagem) partes.push(d.mensagem);
      if (d.impressao_digital) partes.push('impressão digital ' + d.impressao_digital);
      if (r.strevento === 'eleicao.zeresima' && d.cedulas !== undefined) partes.push(`${d.comparecimentos} comparecimento(s), ${d.cedulas} cédula(s), ${d.votos_apurados} voto(s); ${d.eleitores_aptos} eleitor(es) apto(s)`);
      else if (d.cedulas !== undefined) partes.push(`${d.cedulas} cédula(s), ${d.comparecimentos} comparecimento(s), aberta pelo ${d.aberta_por}`);
      if (d.dtafinal_nova) partes.push(`término: ${this.dataHora(d.dtafinal_anterior)} → ${this.dataHora(d.dtafinal_nova)}`);
      if (d.justificativa) partes.push('justificativa: ' + d.justificativa);
      if (d.resposta && d.resposta.papel) partes.push('frase do ' + d.resposta.papel);
      if (d.resposta && d.resposta.importados) partes.push(`${d.resposta.importados.length} importado(s)`);
      if (d.registros !== undefined) partes.push(`${d.registros} registro(s) exportado(s)`);
      if (d.versao) partes.push('versão ' + d.versao);
      if (d.banco) partes.push('banco ' + d.banco);
      if (d.arquivo && r.strevento === 'sistema.migracao') partes.push(d.arquivo);
      if (d.pendentes) partes.push('pendentes: ' + d.pendentes.join(', '));
      if (d.senha_informada) partes.push('senha definida (valor não registrado)');
      if (d.dados && d.dados.strdescricao) partes.push(d.dados.strdescricao);
      if (d.dados && d.dados.strnome && r.strentidade !== 'eleicao') partes.push(d.dados.strnome);
      return partes.join(' · ') || (r.strentidadeid ? `${r.strentidade} ${r.strentidadeid}` : '');
    }
  }
};
</script>

<style>
.tabela-auditoria { font-size: 10pt; }
/* textos longos sem espaço (ex.: nome colado) não podem esticar a tabela */
.tabela-auditoria td.col-detalhes { max-width: 420px; overflow-wrap: anywhere; word-break: break-word; }
.tabela-auditoria td { overflow-wrap: anywhere; }
.tabela-auditoria pre.detalhes { font-size: 9pt; white-space: pre-wrap; word-break: break-all; background: #f7f7f7; padding: 8px; }
code.hash { word-break: break-all; }
</style>
